<template>
    <div class="loginContainer">
        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
            <div style="width: 430px; min-height: 240px; background-color: #fff;">
                <img src="/static/img/login-image.png" alt="logo">
                <el-tabs v-model="activeName">
                    <el-tab-pane :label="$store.getters.getText('login_login_panel')" name="login">
                        <el-form novalidate @submit="login" class="vue-container" autocomplete="on">
                            <div v-if="error" class="error-message" style="font-weight: 700;">
                                <span>{{error}}</span>
                            </div>
                            <el-form-item :label="$store.getters.getText('login_email')">
                                <el-input type="email" v-model="credentials.email" autocomplete="on" required></el-input>
                            </el-form-item>
                            <el-form-item :label="$store.getters.getText('login_password')">
                                <el-input type="password" v-model="credentials.password" autocomplete="on" required></el-input>
                            </el-form-item>
                            <div class="login">
                                <button v-loading="loadingStatus" type="submit" class="greenButton" @click="login()">{{$store.getters.getText('login_button')}}</button>
                            </div>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane :label="$store.getters.getText('login_reset_password_panel')" name="reset">
                        <el-form
                            novalidate
                            class="vue-container"
                        >
                            <el-form-item :label="$store.getters.getText('login_email')">
                                <el-input type="email" v-model="resetEmail" required></el-input>
                            </el-form-item>
                            <div class="reset">
                                <el-button v-loading="sendingRequest" class="greenButton" @click="resetPassword()">{{$store.getters.getText('login_password_reset_button')}}</el-button>
                            </div>
                        </el-form>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import HttpErrorManager from 'fundation-app-vuejs/src/components/partials/http-error-manager.js';
export default {
    data () {
        return {
            activeName: 'login',
            credentials: {
                email: '',
                password: ''
            },
            resetEmail: '',
            error: '',
            loadingStatus: false,
            sendingRequest: false,
            httpErrorManager: null,
        };
    },
    created() {
        this.httpErrorManager = new HttpErrorManager(this.$store.getters.getLangage);
    },
    watch: {
        activeName() {
            this.error = '';
        },
        'credentials.email'() {
            this.error = '';
        },
        'credentials.password'() {
            this.error = '';
        }
    },
    methods: {
        login () {
            var credentials = {
                email: this.credentials.email,
                password: this.credentials.password
            };
            this.loadingStatus = true,

            this.$store.dispatch('loginUser', credentials).then(() => {
                this.$router.push({name: 'home'});
            }).catch((error) => {
                let error_message = this.httpErrorManager.getMessage(
                    error.status,
                    error.data._errors
                )
                if (error_message === '') {
                    error_message = this.httpErrorManager.getMessage(
                        401,
                        'WRONG_AUTH_CREDENTIALS'
                    ); // viveco's concrete is an older version that has less error codes
                }
                this.$set(this, 'error', error_message);
            }).finally(() => {
                this.loadingStatus = false;
            });

        },
        resetPassword() {
            if (this.resetEmail) {
                this.$set(this, 'error', '');
                this.$set(this, 'sendingRequest', true);

                this.$store.dispatch('selfResetUserPassword', {
                    email: this.resetEmail,
                    url_front: window.location.origin
                }).then((res) => {
                    // cannot fix and package fundation atm (edf delivery 22 oct, technicallyy writing this 23 oct though)
                    // a patch of 'selfResetUserPassword' is needed and an issue will be opened
                    if (res.status >= 400) {
                        throw (res);
                    } else {
                        this.$notify.success({
                            message: this.$store.getters.getText('login_password_reset_success')
                        });
                    }
                }).catch((error) => {
                    this.$notify.error({
                        message: this.$store.getters.getText('login_password_reset_failed')
                    });
                }).finally(() => {
                    this.$set(this, 'sendingRequest', false);
                })
            } else {
                this.$set(this, 'error', '');
                return false;
            }
        },
    }
};
</script>

<style lang=less>
@import '../../less/variables.less';
.loginContainer{
    width:100%;
    height:100%;
    position: fixed;
    top:0px;
    left:0px;
    z-index:10 !important;
    background: #23262B;
    color: #555;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    line-height: 1.42857143;
    font-weight: 300;
    .el-tabs {
        .el-tabs__header {
            padding: 0 25px;
        }
        .el-tabs__active-bar {
            background-color: @color-1 !important;
        }
        .el-tabs__item.is-active, .el-tabs__item:hover {
            color: @color-1;
        }
        .el-form-item {
            width: 90%;
            margin: auto;
            input:focus {
                border-color: @color-1;
            }
        }
    }
    .login, .reset {
        text-align: center !important;
        margin-top: 20px;
    }
    .error-message {
        color: #f56c6c;
        padding-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/login.vue